<template>
  <svg
    viewBox="0 0 30 30"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m15 0a15 15 0 1 0 15 15 15 15 0 0 0 -15-15zm-13.42 15a13.33 13.33 0 0 1 3.35-8.86l2.67 2.64c.87.85 2.2-.47 1.34-1.32l-2.67-2.64a13.41 13.41 0 0 1 18.87 19l-1-1a.65.65 0 0 0 -.16-.13l-.43-.46c-.82-.87-2.11.48-1.28 1.36l1.42 1.41.13.11a13.41 13.41 0 0 1 -22.24-10.11z"
      fill="#4f2b1b"
    />
    <path
      d="m21.92 8.75-4.82 1.7a.08.08 0 0 0 0 .06v.09a.19.19 0 0 0 -.11-.18h.09.05l4.77-1.69a.07.07 0 0 0 0-.12l-4-1.74a.5.5 0 0 0 -.32 0l-5 1.73s-.06 0 0 0a.17.17 0 0 0 -.14.17l-.08 5.84a.19.19 0 0 0 .13.18l4.26 1.52a.18.18 0 0 0 .25-.17s0 .15 0 .13l4.51-1.58a.39.39 0 0 0 .27-.36l.22-5.52a.06.06 0 0 0 -.08-.06z"
      fill="#fff"
    />
    <path
      d="m22.25 8.38-.25-.15-3.92-1.74a.91.91 0 0 0 -.65 0l-5 1.75h-.12a.65.65 0 0 0 -.29.54l-.08 5.83a.65.65 0 0 0 .43.62l4.26 1.53a.76.76 0 0 0 .21 0s0 0 .06 0l4.77-1.67a.86.86 0 0 0 .58-.78l.24-5.58a.54.54 0 0 0 -.24-.35zm-4.54-1.05 3 1.34-1.57.56-2.1.74-2-.83-1.15-.48zm-1.18 8.47-3.71-1.33.07-5.24 1.25.52 2.46 1zm4.82-1.5-3.89 1.37.06-4.87 1.95-.69 2.05-.73z"
      fill="#4f2b1b"
    />
    <path
      d="m15 11.87-4.8 1.77a.07.07 0 0 0 0 .06v.08a.16.16 0 0 0 -.12-.17h.1.05l4.75-1.75a.06.06 0 0 0 0-.11l-4-1.69a.44.44 0 0 0 -.32 0l-5.01 1.8a.19.19 0 0 0 -.14.18v5.84a.17.17 0 0 0 .13.17l4.27 1.47a.19.19 0 0 0 .25-.18c0 .05 0 .15 0 .14l4.5-1.64a.4.4 0 0 0 .26-.37l.08-5.55a.05.05 0 0 0 0-.05z"
      fill="#fff"
    />
    <path
      d="m15.28 11.5-.28-.15-3.92-1.69a.86.86 0 0 0 -.65 0l-5 1.82h-.12a.64.64 0 0 0 -.28.54v5.84a.64.64 0 0 0 .44.61l4.25 1.53a.76.76 0 0 0 .21 0h.07l4.75-1.74a.84.84 0 0 0 .57-.78l.16-5.59a.5.5 0 0 0 -.2-.39zm-4.55-1 3.06 1.3-1.57.58-2.09.77-2-.81-1.17-.47zm-1.07 8.5-3.73-1.29v-5.24l1.26.53 2.47 1zm4.8-1.56-3.88 1.42v-4.86l1.94-.71 2.05-.76z"
      fill="#4f2b1b"
    />
    <path
      d="m22.25 15.6-5 1.08a.07.07 0 0 0 0 .05v.09a.17.17 0 0 0 -.09-.19l.09.05 5-1.08a.06.06 0 0 0 0-.11l-3.73-2.23a.44.44 0 0 0 -.32-.06l-5.2 1.09s0 0 0 0a.18.18 0 0 0 -.16.15l-.84 5.81a.2.2 0 0 0 .1.2l4 2.05a.19.19 0 0 0 .27-.14s-.06.14 0 .13l4.68-1a.38.38 0 0 0 .31-.32l.94-5.5a.06.06 0 0 0 -.05-.07z"
      fill="#fff"
    />
    <path
      d="m22.62 15.28-.23-.18-3.67-2.23a1 1 0 0 0 -.64-.11l-5.21 1.11h-.12a.63.63 0 0 0 -.36.49l-.82 5.78a.65.65 0 0 0 .35.67l4 2.05a.76.76 0 0 0 .2.06s0 0 .07 0l4.94-1.06a.85.85 0 0 0 .68-.69l.94-5.51a.5.5 0 0 0 -.13-.38zm-4.37-1.61 2.85 1.71-1.63.35-2.18.47-1.89-1.08-1.09-.62zm-2.25 8.24-3.52-1.79.74-5.18 1.18.67 2.3 1.33zm5-.91-4 .86.68-4.83 2-.43 2.13-.46z"
      fill="#4f2b1b"
    />
  </svg>
</template>
